import { PeerConnection } from "@/utils/peer"
import RawMetadataLoaderWorkerUrl from "./metadata-loader.worker.ts?worker&url"
import { MetadataLoaderWorker } from "./metadata-loader.worker"

export const MetadataLoaderConnection = new PeerConnection<MetadataLoaderWorker>(
	RawMetadataLoaderWorkerUrl,
	{
		label: "Metadata Loader",
	},
)

export const PreviewLoaderConnection = new PeerConnection<MetadataLoaderWorker>(
	RawMetadataLoaderWorkerUrl,
	{
		label: "Preview Loader",
	},
)
